import React, { useMemo, useContext } from "react";
import ChartContainer from "../chart-container";
import lang from "translations";
import { Path } from "paths";
import { ProductNamePopover } from "components/popovers";
import { StaffContext } from "contexts";
import styles from "./ranked-chart.module.scss";

const TopProductsChart = ({ ...props }) => {
  const { staff } = useContext(StaffContext);
  const linkLocation = !(staff?.roles?.includes("FRONT_OFFICE") && staff?.roles?.length === 1);
  const data = useMemo(() => {
    return props.mappedData.map((p, index) => {
      return {
        id: p.id || `${p.name}-${index}`,
        rank: index + 1,
        name: p.name,
        deleted: p.deleted,
        unitSold: p.unitSold,
      };
    });
  }, [props.mappedData]);
  const isEmpty = !props.mappedData.length;

  return (
    <ChartContainer
      title={ linkLocation ? { to: Path.PRODUCT, name: lang.topProducts } : { name: lang.topProducts }}
      {...props}
      empty={false}
      paddingless
      className={styles.card}
    >
      {isEmpty ? (
        <div className={styles.emptyState}>{lang.noDataAvailable}</div>
      ) : (
        <div className={styles.table}>
        <div className={styles.headerRow}>
          <span className="text-xs">{lang.product}</span>
          <span className="text-xs">{lang.unitsSold}</span>
        </div>

        {data.slice(0, 5).map((product) => (
          <div className={styles.row} key={product.id}>
            <span className={styles.left}>
              <span className={styles.rank}>{product.rank}</span>
              {product.deleted ? (
                <span className={styles.name}>
                  {`${product.name} (Deleted)`}
                </span>
              ) : (
                <ProductNamePopover productId={product.id}>
                  <a
                    className={`${styles.name} ${styles.link}`}
                    href={`/product/edit/${product.id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {product.name}
                  </a>
                </ProductNamePopover>
              )}
            </span>
            <span className={styles.value}>
              <span className="font-semibold text-base text-[var(--teal)]">{product.unitSold}</span>
            </span>
          </div>
        ))}
        </div>
      )}
    </ChartContainer>
  );
};

export default TopProductsChart;
